import React from 'react'
import './inspired.scss'
import {graphql, useStaticQuery} from "gatsby";
import {GatsbyImage, getImage, withArtDirection} from 'gatsby-plugin-image'

const Inspired = () => {


  const {
    inspired1: {childImageSharp: inspired1},
    inspired2: {childImageSharp: inspired2},
    inspired3: {childImageSharp: inspired3},
    inspired4: {childImageSharp: inspired4},
    inspired5: {childImageSharp: inspired5},
    inspired6: {childImageSharp: inspired6},
  } = useStaticQuery(graphql`
      {
          inspired1: file(name: { eq: "inspired-1" }) {
              childImageSharp {
                  gatsbyImageData
              }
          }
          inspired2: file(name: { eq: "inspired-2" }) {
              childImageSharp {
                  gatsbyImageData
              }
          }
          inspired3: file(name: { eq: "inspired-3" }) {
              childImageSharp {
                  gatsbyImageData
              }
          }
          inspired4: file(name: { eq: "inspired-4" }) {
              childImageSharp {
                  gatsbyImageData
              }
          }
          inspired5: file(name: { eq: "inspired-5" }) {
              childImageSharp {
                  gatsbyImageData
              }
          }
          inspired6: file(name: { eq: "inspired-6" }) {
              childImageSharp {
                  gatsbyImageData
              }
          }
      }
  `)

  const inspiredImg = [
    inspired1,
    inspired2,
    inspired3,
    inspired4,
    inspired5,
    inspired6,
  ]


  return (
    <section className='f-inspired'>
      <div className='f-inspired__wrapper'>
        <h2 className='f-inspired__title'>¡INSPÍRATE! Así lo han hecho otras embajadoras</h2>

        <div className='f-inspired__cards'>
          {inspiredImg.map((item, i) => {
            return(
              <div key={`card-${i}`}  className='f-inspired__card'>
                <GatsbyImage
                  objectFit="cover"
                  image={getImage(item)}
                  alt="Aprende Más"
                  className="f-inspired__card__image"
                />
              </div>
            )
          })}

        </div>
      </div>

    </section>
  )
}

export default Inspired
